//#region src/bite_log_card_connect_event.ts
var BiteLogCardConnectEvent = /* @__PURE__ */ function(BiteLogCardConnectEvent) {
	BiteLogCardConnectEvent[BiteLogCardConnectEvent["TerminalDisconnected"] = 1] = "TerminalDisconnected";
	BiteLogCardConnectEvent[BiteLogCardConnectEvent["UpdateIdleTextError"] = 2] = "UpdateIdleTextError";
	/** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
	BiteLogCardConnectEvent[BiteLogCardConnectEvent["AuthAndCaptureDeprecated"] = 7] = "AuthAndCaptureDeprecated";
	return BiteLogCardConnectEvent;
}(BiteLogCardConnectEvent || {});
//#endregion
export { BiteLogCardConnectEvent };

//# sourceMappingURL=bite_log_card_connect_event.js.map